import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import featureFlagsApiClient from '../../api/feature_flags/client';

export interface featureFlagsState {
  featureFlags: string[];
  actions: {
    fetchFeatureFlags: AsyncActionState<string[]>;
  };
}

const initialState: featureFlagsState = {
  featureFlags: [],
  actions: {
    fetchFeatureFlags: { status: 'uninitialized' },
  },
};

const slice = setupSlice('featureFlags', initialState)
  .addAsyncSagas({
    fetchFeatureFlags: invoke(featureFlagsApiClient.fetchFeatureFlags),
  })
  .addReducers({
    'fetchFeatureFlags/fulfilled': (state, action) => {
      state.featureFlags = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
